import { Component } from '@angular/core';
import { DashboardWidgetsDataService } from 'src/app/services/dashboard-widget-data.service';

@Component({
  selector: 'app-trend-to-target-idd-widget',
  templateUrl: './trend-to-target-idd-widget.component.html',
  styleUrl: './trend-to-target-idd-widget.component.scss',
  standalone: false
})
export class TrendToTargetIddWidgetComponent {
  trendToTargetIddData: any[] = [];
  
  dashStyle = 'dash';

  monthNames: string[] = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  constructor(
    private dashboardWidgetsDataService: DashboardWidgetsDataService
  ) {
    this.customizeTrendToTargetIddText = this.customizeTrendToTargetIddText.bind(this);
  }

   ngOnInit() {
    this.dashboardWidgetsDataService.getTrendToTargetIddData().subscribe(data => {
      if (data) {
        this.trendToTargetIddData = data.map(d => ({
          ...d,
          sumIddHoursTarget: Math.round(d.sumIddMinutesTarget / 60),
          sumIddHoursReached: Math.round(d.sumIddMinutesReached / 60)
        }));
      }
    });
  }

  customizeTrendToTargetIddText(arg: any) {
    return this.monthNames[arg.value - 1];
  }
}
